<form [formGroup]="form | bgoAsFormGroup" *transloco="let t">
  <div class="w-2/3">
    <label for="constructionYear" class="font-bold">
      {{ t('createJobRequest.renewableEnergyConsultingForm.constructionYearQuestion') }}</label
    >
    <cft-form-field id="constructionYear">
      <label>{{ t('createJobRequest.renewableEnergyConsultingForm.constructionYear') }}</label>
      <input
        type="number"
        [formControl]="form.controls.constructionYear | bgoAsFormControl"
        data-testid="construction-year"
      />
      <span class="error">
        {{ t('createJobRequest.renewableEnergyConsultingForm.errors.constructionYearRequired') }}
      </span>
    </cft-form-field>
  </div>
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.constructionYear.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.renewableEnergyConsultingForm.heatingType.label') }}</label>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.heatingType | bgoAsFormControl"
      [value]="HeatingType.Wood"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingType.wood') }}
    </cft-radio>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.heatingType | bgoAsFormControl"
      [value]="HeatingType.Gas"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingType.gas') }}
    </cft-radio>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.heatingType | bgoAsFormControl"
      [value]="HeatingType.Pellet"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingType.pellet') }}
    </cft-radio>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.heatingType | bgoAsFormControl"
      [value]="HeatingType.Oil"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingType.oil') }}
    </cft-radio>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.heatingType | bgoAsFormControl"
      [value]="HeatingType.Electric"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingType.electric') }}
    </cft-radio>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.heatingType | bgoAsFormControl"
      [value]="HeatingType.Solar"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingType.solar') }}
    </cft-radio>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.heatingType | bgoAsFormControl"
      [value]="HeatingType.Other"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingType.other') }}
    </cft-radio>
    @if (form.controls.heatingType.touched && form.controls.heatingType.invalid) {
      <span class="error">
        {{ t('createJobRequest.renewableEnergyConsultingForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.heatingType.invalid">
    <label class="mt-xs font-bold">{{
      t('createJobRequest.renewableEnergyConsultingForm.heatingSystemAge.label')
    }}</label>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.heatingSystemAge | bgoAsFormControl"
      [value]="HeatingSystemAge.MoreThan_10Years"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingSystemAge.moreThan10Years') }}
    </cft-radio>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.heatingSystemAge | bgoAsFormControl"
      [value]="HeatingSystemAge.LessThan_10Years"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingSystemAge.lessThan10Years') }}
    </cft-radio>
    <cft-radio
      class="mt-xs block"
      [formControl]="form.controls.heatingSystemAge | bgoAsFormControl"
      [value]="HeatingSystemAge.Unknown"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingSystemAge.unknown') }}
    </cft-radio>
    @if (form.controls.heatingType.touched && form.controls.heatingType.invalid) {
      <span class="error">
        {{ t('createJobRequest.renewableEnergyConsultingForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.heatingSystemAge.invalid">
    <label class="mt-xs font-bold">
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingSystemConsumption.label') }}
      {{
        t(
          'createJobRequest.renewableEnergyConsultingForm.heatingSystemConsumption.measurement.' +
            form.controls.heatingType.value
        )
      }}
    </label>
    <cft-form-field class="md:w-1/2">
      <input type="number" [formControl]="form.controls.heatingEnergyConsumption | bgoAsFormControl" />
      <span class="error">
        {{ t('createJobRequest.renewableEnergyConsultingForm.errors.heatingEnergyConsumptionRequired') }}
      </span>
    </cft-form-field>
  </div>
  <div
    class="gradual-reveal mt-2xl space-y-md"
    [class.gradual-reveal-hidden]="form.controls.heatingEnergyConsumption.invalid"
  >
    <label class="mt-xs font-bold">
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingSystem.label') }}
    </label>
    <cft-radio
      class="block"
      [formControl]="form.controls.heatingSystem | bgoAsFormControl"
      [value]="HeatingSystem.Floor"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingSystem.floor') }}
    </cft-radio>
    <cft-radio
      class="block"
      [formControl]="form.controls.heatingSystem | bgoAsFormControl"
      [value]="HeatingSystem.RadiatorLowTemp"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingSystem.radiatorLowTemp') }}
    </cft-radio>
    <cft-radio
      class="block"
      [formControl]="form.controls.heatingSystem | bgoAsFormControl"
      [value]="HeatingSystem.RadiatorHighTemp"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingSystem.radiatorHighTemp') }}
    </cft-radio>
    <cft-radio
      class="block"
      [formControl]="form.controls.heatingSystem | bgoAsFormControl"
      [value]="HeatingSystem.Unknown"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingSystem.unknown') }}
    </cft-radio>
    <cft-radio
      class="block"
      [formControl]="form.controls.heatingSystem | bgoAsFormControl"
      [value]="HeatingSystem.Other"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.heatingSystem.other') }}
    </cft-radio>
    @if (form.controls.heatingSystem.touched && form.controls.heatingSystem.invalid) {
      <span class="error">
        {{ t('createJobRequest.renewableEnergyConsultingForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
  <div
    class="gradual-reveal mt-2xl w-2/3 md:w-1/2 xl:w-1/3"
    [class.gradual-reveal-hidden]="form.controls.heatingSystem.invalid"
  >
    <cft-form-field>
      <label>{{ t('createJobRequest.renewableEnergyConsultingForm.heatedAreaLabel') }}</label>
      <input type="number" [formControl]="form.controls.heatedAreaSquareMeters | bgoAsFormControl" />
      <span class="error">
        {{ t('createJobRequest.renewableEnergyConsultingForm.errors.heatedAreaRequired') }}
      </span>
    </cft-form-field>
  </div>
  <div
    class="gradual-reveal mt-2xl space-y-md"
    [class.gradual-reveal-hidden]="form.controls.heatedAreaSquareMeters.invalid"
  >
    <label class="mt-xs font-bold">
      {{ t('createJobRequest.renewableEnergyConsultingForm.boilerSystem.label') }}
    </label>
    <cft-radio
      class="block"
      [formControl]="form.controls.boilerSystem | bgoAsFormControl"
      [value]="BoilerSystem.ConnectedToHeating"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.boilerSystem.connectedToHeating') }}
    </cft-radio>
    <cft-radio
      class="block"
      [formControl]="form.controls.boilerSystem | bgoAsFormControl"
      [value]="BoilerSystem.Electric"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.boilerSystem.electric') }}
    </cft-radio>
    <cft-radio
      class="block"
      [formControl]="form.controls.boilerSystem | bgoAsFormControl"
      [value]="BoilerSystem.HeatPump"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.boilerSystem.heatPump') }}
    </cft-radio>
    <cft-radio
      class="block"
      [formControl]="form.controls.boilerSystem | bgoAsFormControl"
      [value]="BoilerSystem.Unknown"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.boilerSystem.unknown') }}
    </cft-radio>
    @if (form.controls.boilerSystem.touched && form.controls.boilerSystem.invalid) {
      <span class="error">
        {{ t('createJobRequest.renewableEnergyConsultingForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
  <div
    class="gradual-reveal mt-2xl space-y-md"
    [class.gradual-reveal-hidden]="form.controls.heatedAreaSquareMeters.invalid"
  >
    <label class="mt-xs font-bold">
      {{ t('createJobRequest.renewableEnergyConsultingForm.buildingOccupantsLabel') }}
    </label>
    <cft-number-input
      [formControl]="form.controls.buildingOccupants | bgoAsFormControl"
      [min]="1"
      [max]="200"
      [step]="1"
    >
      <span content="error">
        {{ t('createJobRequest.renewableEnergyConsultingForm.errors.buildingOccupantsRequired') }}
      </span>
    </cft-number-input>
  </div>
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.buildingOccupants.invalid">
    <label class="mt-xs font-bold">
      {{ t('createJobRequest.renewableEnergyConsultingForm.buildingType.label') }}
    </label>
    <cft-radio
      class="block"
      [formControl]="form.controls.buildingType | bgoAsFormControl"
      [value]="BuildingType.SingleFamily"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.buildingType.singleFamily') }}
    </cft-radio>
    <cft-radio
      class="block"
      [formControl]="form.controls.buildingType | bgoAsFormControl"
      [value]="BuildingType.MultiFamily"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.buildingType.multiFamily') }}
    </cft-radio>
    @if (form.controls.buildingType.touched && form.controls.buildingType.invalid) {
      <span class="error">
        {{ t('createJobRequest.renewableEnergyConsultingForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
  <div
    class="gradual-reveal mt-2xl space-y-md"
    [class.gradual-reveal-hidden]="
      form.controls.buildingType.invalid || form.controls.buildingType.value === BuildingType.SingleFamily
    "
  >
    <label class="mt-xs font-bold">
      {{ t('createJobRequest.renewableEnergyConsultingForm.numberOfApartments.label') }}
    </label>
    <cft-radio
      class="block"
      [formControl]="form.controls.numberOfApartments | bgoAsFormControl"
      [value]="NumberOfApartments.SixOrLess"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.numberOfApartments.lessThanSix') }}
    </cft-radio>
    <cft-radio
      class="block"
      [formControl]="form.controls.numberOfApartments | bgoAsFormControl"
      [value]="NumberOfApartments.MoreThanSix"
    >
      {{ t('createJobRequest.renewableEnergyConsultingForm.numberOfApartments.moreThanSix') }}
    </cft-radio>
    @if (form.controls.numberOfApartments.touched && form.controls.numberOfApartments.invalid) {
      <span class="error">
        {{ t('createJobRequest.renewableEnergyConsultingForm.errors.atLeastOneOptionSelected') }}
      </span>
    }
  </div>
  @if (
    {
      numberOfApartmentsInvalid: form.controls.numberOfApartments.invalid,
      buildingTypeInvalid: form.controls.buildingType.invalid,
    };
    as validity
  ) {
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="validity.numberOfApartmentsInvalid || validity.buildingTypeInvalid"
    >
      <label class="mt-xs font-bold">
        {{ t('createJobRequest.renewableEnergyConsultingForm.recentRenovations.yesNoLabel') }}
      </label>
      <cft-radio class="block" [formControl]="form.controls.recentRenovations | bgoAsFormControl" [value]="true">
        {{ t('createJobRequest.renewableEnergyConsultingForm.recentRenovations.yes') }}
      </cft-radio>
      <cft-radio class="block" [formControl]="form.controls.recentRenovations | bgoAsFormControl" [value]="false">
        {{ t('createJobRequest.renewableEnergyConsultingForm.recentRenovations.no') }}
      </cft-radio>
    </div>
  }
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="!form.controls.recentRenovations.value">
    <cft-form-field class="h-full" [autogrow]="true">
      <label for="message">{{
        t('createJobRequest.renewableEnergyConsultingForm.recentRenovations.renovationsDescriptionLabel')
      }}</label>
      <textarea id="message" [formControl]="form.controls.recentRenovationsDescription | bgoAsFormControl"></textarea>
    </cft-form-field>
  </div>
</form>
